import React from 'react';

import { SvgList, Svg, ListItemCard } from './styles';

function FooterFlags() {
  const PATH = '/ecommerce.svg#';
  const cards = ['visa', 'mastercard', 'diners', 'elo', 'hipercard', 'american', 'discover', 'jcb', 'aura', 'cabal'];

  return (
    <SvgList>
      {cards.map((card) => (
        <ListItemCard key={card} title={card.toUpperCase()}>
          <Svg>
            <use xmlnsXlink="http://www.w3.org/1999/xlink" xlinkHref={`${PATH}card-new-${card}`} />
          </Svg>
        </ListItemCard>
      ))}
    </SvgList>
  );
}

export default FooterFlags;
